import React, { FC } from 'react';

import Link from 'buyside/components/presentation/Link/link';
import NavigationUserInfoSection from 'buyside/components/presentation/MainSiteNavigation/TopNavigation/NavigationUser/NavigationUserInfo/navigationUserInfoSection';

import { NavigationUserInfoQuery } from 'interfaces/graphql-typings';

const UserPrimaryContact: FC<{
  primaryContact: NonNullable<
    NonNullable<NavigationUserInfoQuery['currentUser']>['primaryContact']
  >;
}> = ({ primaryContact }) => {
  const { displayName, email } = primaryContact;

  return (
    <NavigationUserInfoSection title="Your SumZero Representative">
      <p>{displayName}</p>
      <Link to={`mailto:${email}`}>{email}</Link>
    </NavigationUserInfoSection>
  );
};

export default UserPrimaryContact;
